import MainLayout from "@/components/layout/MainLayout.vue";
import Pagination from "laravel-vue-pagination";
import moment from "moment";
import axios from "axios";
import { mapGetters } from "vuex";
import { ConvertNumService } from '@/assets/js/convertNumberService.js';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import { fetchNotificationCount } from "@/services/common/notification-service";

const convertNumberService = new ConvertNumService();

export default {
    name: "courseRequestList",

    components: {
        MainLayout,
        Pagination,
        AdvancedLaravelVuePaginate
    },

    data() {
        return {
            pg_status: false,
            pg_sortby: false,
            keyword: "",
            sortBy: "",
            course_requests: {},
            lastPage: "",
            currentPage: ""
        };
    },

    computed: {
        ...mapGetters(["teacherId", "studentId", "userType"]),
    },

    filters: {
        shorttext(value, limit) {
            if (value) {
                return value.substring(0, limit);
            }
        },
        setMoment: function (date) {
            return moment(date).format("DD MMMM YYYY");
        }
    },

    methods: {
        getCourseRequest(page = 1) {
            axios.get("/course/request/list?page=" + page)
                .then((response) => {
                    this.course_requests = response.data;
                    this.course_requests.total = convertNumberService.convertEng2Mm(this.course_requests.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.course_requests.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.course_requests.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Course Request API Error", error);
                });
        },

        onChange(page = 1) {
            axios.get("/course/request/list/sort?page=" + page, {
                    params: {
                        course_request_title: this.keyword,
                        keyword: this.sortBy
                    }
                })
                .then((response) => {
                    this.pg_sortby = true;
                    this.course_requests = response.data;
                    this.course_requests.total = convertNumberService.convertEng2Mm(this.course_requests.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.course_requests.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.course_requests.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("Sort CourseRequest API Error", error);
                });
        },
        
        search(page = 1) {
            axios.get("/course/request/list/filter?page=" + page, {
                    params: {
                        keyword: this.keyword
                    }
                })
                .then((response) => {
                    this.pg_status = true;
                    this.course_requests = response.data;
                    this.course_requests.total = convertNumberService.convertEng2Mm(this.course_requests.total);
                    this.lastPage = convertNumberService.convertEng2Mm(this.course_requests.last_page);
                    this.currentPage = convertNumberService.convertEng2Mm(this.course_requests.current_page);
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('/');
                    }
                    console.log("CourseRequest Search API Error", error);
                });
        },
    },

    mounted() {
        this.getCourseRequest();
        fetchNotificationCount();
    }
};
